import apiClient from './axiosClient';

export const getVendors = () => apiClient.get(`/vendors/`);
export const getVendor = (id) => apiClient.get(`/vendors/${id}/`);
export const createVendor = (data) => apiClient.post(`/vendors/`, data);
export const updateVendor = (id, data) => apiClient.put(`/vendors/${id}/`, data);
export const patchVendor = (id, data) => apiClient.patch(`/vendors/${id}/`, data);
export const deleteVendor = (id) => apiClient.delete(`/vendors/${id}/`);